<template>
  <b-form-row>
    <b-modal
      size="xl"
      button-size="sm"
      ref="finder"
      hide-footer
      :id="this.id"
      :title="title"
    >
      <TipoDocumentoList :prefix="title" @onDblClickSelect="onDblClickSelect" />
    </b-modal>

    <lg-form-input-finder
      :value="computedValue"
      @input="updateValue"
      fieldDescription="descricao"
      :label="label"
      invalidFeedback="Tipo de Documento deve ser informado!"
      description=""
      @handleClean="handleClean"
      :error="error"
    >
      <template #prepend>
        <b-button
          @click="show"
          class="btn-input-finder"
          pressed
        >
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import TipoDocumentoList from "@/modules/cadastros/tipo-documento/TipoDocumentoList.vue";

export default {
  components: { LgFormInputFinder, TipoDocumentoList },
  props: {
    id: String,
    prefix: {
      type:Array,
      default: ()=>[]
    },
    value: Object,
    error: {
      type: Object,
      default: null,
    },
    label:{
      type:String,
      default: 'Tipo de Documento: *'
    }
  },
  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newValue) {
        this.internalValue = newValue;
      },
    },
    updatedPrefix() {
      return [...this.prefix, "Tipo de Documento"].filter(value=> value != "");
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit('input', newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit('input', {});
    },
    onDblClickSelect(item) {
      this.computedValue = item;
      this.$emit('input', item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
